// src/app/slices/accessDoorSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AccessoryState, IAccessDoor, IAccessDoorParams } from '../models';
import { deleteAccessory } from './actions';

const initialState: AccessoryState<IAccessDoor, IAccessDoorParams> = {
  accessories: {},
  params: null,
};

const accessDoorSlice = createSlice({
  name: 'access_door',
  initialState,
  reducers: {
    setAccessDoor: (state, action: PayloadAction<IAccessDoor>) => {
      if (!state.accessories[action.payload.section_id])
        state.accessories[action.payload.section_id] = {};
      state.accessories[action.payload.section_id][action.payload.id] =
        action.payload;
    },
    setAccessDoorParams: (state, action: PayloadAction<IAccessDoorParams>) => {
      state.params = action.payload;
    },
    deleteAccessDoor: deleteAccessory,
  },
});

export const { setAccessDoor, setAccessDoorParams, deleteAccessDoor } =
  accessDoorSlice.actions;

export default accessDoorSlice.reducer;
